/*
  Скан протокола у дома: имя файла ссылкой на скачивание, под ним - что человек
  подтвердил при внесении (организация). Нет скана - ничего не рисуется.

  Отказ скачивания показывается здесь же, рядом с нажатым, а не общим блоком
  страницы (правило 3 скилла `frontend`).
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { fileSize } from '../api/format.js'
import { Notice } from './Common.jsx'

export default function ProtocolScanLink({ sectionId, building }) {
  const [failure, setFailure] = useState(null)
  const scan = building.protocol_scan
  if (!scan) return null

  async function save() {
    setFailure(null)
    try {
      // Без участка (02.11.2026, вкладка «Подсудность домов») - путём дома.
      await (sectionId
        ? api.downloadProtocolScan(sectionId, building.id, scan.filename)
        : api.downloadHouseProtocolScan(building.id, scan.filename))
    } catch (error) {
      setFailure(error)
    }
  }

  return (
    <div className="muted">
      скан:{' '}
      <button type="button" className="link-button" onClick={save}>
        {scan.filename}
      </button>{' '}
      ({fileSize(scan.size_bytes)})
      {scan.organisation ? <div>организация в протоколе: {scan.organisation}</div> : null}
      <Notice error={failure} />
    </div>
  )
}
